/**
 * Internal UI label for a clinic: prefer shortName when set, else full name.
 * Print / patient-facing copy should use `name` directly.
 */
export const clinicDisplayName = (clinic: {
  name?: string | null;
  shortName?: string | null;
} | null | undefined): string => {
  const short = clinic?.shortName?.trim();
  if (short) return short;
  return clinic?.name?.trim() || '';
};
